import React from 'react'

// Mesh generica da clonare
const ClonedObject = ({ position, rotation, scale, mesh, mustHaveLight = false }) => {
  return (    
    <group position={position} rotation={rotation} scale={scale}> 
      {mesh}
      {mustHaveLight && <pointLight intensity={80} color={"#ffffff"} position={[0, 0.5, 0]}/>}    
    </group>
  )
}

export default ClonedObject;
